import { xl } from '../common';
import { ParticleWaveBackground } from '../lib/ParticleWaveBackground';
import ScrollTrigger from 'gsap/ScrollTrigger';

export function initGetStartedRed() {
  const parent = document.querySelector('.get-started-red');
  if (!parent) return;

  const inner = parent.querySelector('.get-started-red__bg');

  const animation = new ParticleWaveBackground(inner, {
    autoStart: false,
    planeWidth: 13.699,
    planeHeight: 5.282,
    widthSegments: 132,
    heightSegments: 88,
    particleSize: 0.035,
    waveHeight: 0.5,
    noiseScale: 2,
    animationSpeed: 6000,
    gradient: [
      { color: '#ffffffff', stop: 0 },
      { color: '#ffffffbb', stop: 100 },
    ],
    rotation: {
      x: -0.797964534011807,
      y: 0.282743338823081,
      z: -0.100530964914873,
    },
    cameraPosition: [-4.26, -0.58, 5],
    cameraRotation: { x: 0, y: 0, z: 0 },
    autoStart: false,
    hoverRadius: 1,
    hoverStrength: 0.5,
    hoverSpringStiffness: 40,
    hoverSpringDamping: 10,
  });

  ScrollTrigger.create({
    trigger: parent,
    start: 'top bottom',
    end: 'bottom top',
    onEnter: () => animation.startAnimation(),
    onLeave: () => animation.stopAnimation(),
    onEnterBack: () => animation.startAnimation(),
    onLeaveBack: () => animation.stopAnimation(),
  });
}
